// src/app/common/services/preview.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreviewService {
  
  private draftModeSubject$ = new BehaviorSubject<boolean>(false);
  public draftMode$ = this.draftModeSubject$.asObservable();

  private previewModeSubject$ = new BehaviorSubject<boolean>(false);
  public previewMode$ = this.previewModeSubject$.asObservable();

  enableDraftMode(): void {
    this.draftModeSubject$.next(true);
  }

  disableDraftMode(): void {
    this.draftModeSubject$.next(false);
  }

  isDraftMode(): boolean {
    return this.draftModeSubject$.getValue();
  }

  enablePreviewMode(): void {
    this.previewModeSubject$.next(true);
  }

  disablePreviewMode(): void {
    this.previewModeSubject$.next(false);
  }

  isPreviewMode(): boolean {
    return this.previewModeSubject$.getValue();
  }


}